import { render } from "./AiAuths.vue?vue&type=template&id=25e67772&scoped=true"
import script from "./AiAuths.vue?vue&type=script&lang=js"
export * from "./AiAuths.vue?vue&type=script&lang=js"

import "./AiAuths.vue?vue&type=style&index=0&id=25e67772&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e67772"]])

export default __exports__